import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../services/API/api.service';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertService } from '../../services/Alert/alert.service';

@Component({
  selector: 'app-products-details',
  templateUrl: './products-details.component.html',
  styleUrls: ['./products-details.component.scss']
})
export class ProductsDetailsComponent implements OnInit {

  selectedProduct: any = {};
  selectedSize: number | null = null;
  quantity: number = 1;
  extras: any[] = []; // For future implementation if needed
  selectedExtras: any[] = [];
  productId: number = 0;
  productName: string = '';
  selectedFreeSides: any[] = [];
  extraQuantities: { [key: number]: number } = {};


  constructor(private route: ActivatedRoute,private apiService: ApiService,private alertService: AlertService) {
      this.route.params.subscribe(params => {
        if(params.id){
          this.productId = params.id;
          this.productName = params.name;
        }
      });
    }

  ngOnInit(): void {
    this.selectProduct(this.productId);
  }

  // selectProduct(productId: number) {
  //   if (productId) {
  //     this.apiService.getSelectedProduct(productId).subscribe({
  //       next: response => {
  //         this.selectedProduct = response.data.selectedProduct;
  //         console.log(this.selectedProduct);
          
  //         // Reset selections
  //         this.selectedExtras = [];
  //         this.selectedFreeSides = [];
  //         this.extraQuantities = {};
          
  //         // Initialize extras with quantity 0
  //         if (this.selectedProduct.extraproducts) {
  //             this.selectedProduct.extraproducts.forEach(extra => {
  //                 this.extraQuantities[extra.id] = 0;
  //             });
  //         }
          
  //         // Auto-select first size if available
  //         if (this.selectedProduct.types?.length) {
  //             this.selectedSize = this.selectedProduct.types[0].id;
  //         }
  //       }, 
  //       error: (error: HttpErrorResponse) => {
  //         console.log(error);
  //         this.alertService.danger('Something went wrong!');
  //       }
  //     });
  //   }
  // }
  
  updateSelectedExtras() {
    this.selectedExtras = [];
    if (this.selectedProduct.extraproducts) {
      this.selectedProduct.extraproducts.forEach(extra => {
        const quantity = this.extraQuantities[extra.id] || 0;
        if (quantity > 0) {
          // Add the extra product multiple times based on quantity
          for (let i = 0; i < quantity; i++) {
              this.selectedExtras.push(extra);
          }
        }
      });
    }
  }
  calculateDiscountedPrice2(item: any, basePrice: number): number {
    if (!item?.offer) return basePrice;
    
    if (item.offer.type === 'discount') {
      return Math.max(0, basePrice - item.offer.value); // Ensure price doesn't go negative
    } 
    else if (item.offer.type === 'percentage') {
      return basePrice * (1 - item.offer.value / 100);
    }
    
    return basePrice;
  }
  getOfferText(offer: any): string {
    if (!offer) return '';
    
    if (offer.type === 'discount') {
      return `-${offer.value}$`;
    } 
    else if (offer.type === 'percentage') {
      return `-${offer.value}%`;
    }
    
    return '';
  }
  isSideSelected(sideId: number): boolean {
    return this.selectedFreeSides.some(side => side.id === sideId);
  }
  // Extra Products with Quantity Methods
  increaseExtraQuantity(extra: any) {
    if (!this.extraQuantities[extra.id]) {
        this.extraQuantities[extra.id] = 0;
    }
    this.extraQuantities[extra.id]++;
    this.updateSelectedExtras();
  }

  decreaseExtraQuantity(extra: any) {
    if (this.extraQuantities[extra.id] > 0) {
        this.extraQuantities[extra.id]--;
        this.updateSelectedExtras();
    }
  }
  getExtraQuantity(extraId: number): number {
    return this.extraQuantities[extraId] || 0;
  }
  toggleFreeSide(side: any) {
    const index = this.selectedFreeSides.findIndex(s => s.id === side.id);
    
    if (index > -1) {
        // Remove if already selected
        this.selectedFreeSides.splice(index, 1);
    } else {
        // Add if not reached max
        if (this.selectedFreeSides.length < this.selectedProduct.free_side) {
            this.selectedFreeSides.push(side);
        } else {
            this.alertService.danger(`You can only select ${this.selectedProduct.free_side} free sides`);
        }
    }
  }
  // calculateOriginalTotal(): number {
  //   if (!this.selectedProduct || !this.selectedSize) return 0;
    
  //   const selectedType = this.selectedProduct.types.find(t => t.id === this.selectedSize);
  //   if (!selectedType) return 0;
    
  //   let total = selectedType.price * this.quantity;
    
  //   // Add extras
  //   if (this.selectedProduct.extraproducts) {
  //     this.selectedProduct.extraproducts.forEach(extra => {
  //       const quantity = this.extraQuantities[extra.id] || 0;
  //       if (quantity > 0) {
  //         total += extra.price * quantity * this.quantity;
  //       }
  //     });
  //   }
    
  //   // Add free sides with price
  //   if (this.selectedFreeSides && this.selectedFreeSides.length > 0) {
  //     this.selectedFreeSides.forEach(side => {
  //       if (side.price && side.price > 0) {
  //         total += side.price * this.quantity;
  //       }
  //     });
  //   }
    
  //   return total;
  // }

  // calculateTotal(): number {
  //   if (!this.selectedProduct || !this.selectedSize) return 0;
    
  //   // Find the selected size
  //   const selectedType = this.selectedProduct.types.find(t => t.id === this.selectedSize);
  //   if (!selectedType) return 0;
    
  //   // Calculate base price (with discount if applicable)
  //   let basePrice = this.selectedProduct.offer 
  //     ? this.calculateDiscountedPrice2(this.selectedProduct, selectedType.price)
  //     : selectedType.price;
    
  //   let total = basePrice * this.quantity;
    
  //   // Add extras with quantity
  //   if (this.selectedProduct.extraproducts) {
  //     this.selectedProduct.extraproducts.forEach(extra => {
  //       const quantity = this.extraQuantities[extra.id] || 0;
  //       if (quantity > 0) {
  //         total += extra.price * quantity * this.quantity;
  //       }
  //     });
  //   }
    
  //   // Add free sides with price
  //   if (this.selectedFreeSides && this.selectedFreeSides.length > 0) {
  //     this.selectedFreeSides.forEach(side => {
  //       if (side.price && side.price > 0) {
  //         total += side.price * this.quantity;
  //       }
  //     });
  //   }
    
  //   return total;
  // }
  increaseQuantity() {
    if (this.quantity < 99) this.quantity++;
  }

  decreaseQuantity() {
    if (this.quantity > 1) this.quantity--;
  }
  // addToCart() {
  //   if (!this.selectedSize) {
  //       this.alertService.danger('Please select a size');
  //       return;
  //   }

  //   const selectedType = this.selectedProduct.types.find(
  //       (t: any) => t.id === this.selectedSize
  //   );

  //   // Create extras array with name, quantity, and price
  //   const extras: any[] = [];
  //   if (this.selectedProduct.extraproducts) {
  //       this.selectedProduct.extraproducts.forEach(extra => {
  //           const quantity = this.extraQuantities[extra.id] || 0;
  //           if (quantity > 0) {
  //               extras.push({
  //                   name: extra.name,
  //                   quantity: quantity,
  //                   price: extra.price
  //               });
  //           }
  //       });
  //   }

  //   // Get free side IDs
  //   const freeSideIds = this.selectedFreeSides.map(side => side.id);

  //   const cartItem = {
  //       products: [{
  //           product_id: this.selectedProduct.id,
  //           type: selectedType.id,
  //           quantity: this.quantity,
  //           extra: extras, // Array of objects with name, quantity, price
  //           side: freeSideIds // Array of free side IDs
  //       }]
  //   };
  //   console.log('Cart item for API:', cartItem);

  //   const guestMode = sessionStorage.getItem('guestMode');
  //   const token = localStorage.getItem('fontana_token')?.toString();
    
  //   if (cartItem) {
  //       if (token) {
  //           if (this.selectedProduct.id) {
  //               this.apiService.addToCart(cartItem).subscribe({
  //                   next: response => {
  //                       if (response.success == true) {
  //                           this.alertService.success(response.message);
  //                       }
  //                   }, 
  //                   error: (error: HttpErrorResponse) => {
  //                       this.alertService.danger(error.error.message);
  //                   }
  //               });
  //           }
  //       } else if (guestMode) {
  //           // For guest mode, we need to update handleGuestCart to handle the new format
  //           this.handleGuestCart(selectedType, extras, freeSideIds);
  //       } else {
  //           this.alertService.danger('You must be logged in or <a (click)="enableGuestMode()">continue as a guest</a> to add products to your cart');
  //       }
  //   }
  // }
  // private handleGuestCart(selectedType: any, extras: any[], freeSideIds: number[]) {
  //     // Get existing cart items or initialize empty array
  //     let cartItems: any[] = [];
  //     const storedCart = sessionStorage.getItem('cartItems');
      
  //     if (storedCart) {
  //         try {
  //             cartItems = JSON.parse(storedCart);
  //             if (!Array.isArray(cartItems)) {
  //                 cartItems = []; // Reset if corrupted data
  //             }
  //         } catch (e) {
  //             console.error('Error parsing cart items', e);
  //             cartItems = [];
  //         }
  //     }

  //     // Get full free sides information
  //     const selectedFreeSidesFullInfo = this.selectedProduct.sideproducts?.filter(side => 
  //         freeSideIds.includes(side.id)
  //     ).map(side => ({
  //         id: side.id,
  //         name: side.name,
  //         abbrev: side.abbrev,
  //         price: side.price
  //     })) || [];

  //     // Prepare the new item in the exact format you want
  //     const newItem = {
  //         id: this.selectedProduct.id,
  //         name: this.selectedProduct.name,
  //         avatar: this.selectedProduct.avatar,
  //         offer: this.selectedProduct.offer,
  //         rate: this.selectedProduct.rate || 0,
  //         components: this.selectedProduct.components,
  //         types: this.selectedProduct.types,
  //         extraproducts: this.selectedProduct.extraproducts,
  //         selectedTypeId: selectedType.id,
  //         selectedExtraId: extras, // Store extras directly in selectedExtraId as objects
  //         quantity: this.quantity,
  //         category_name: this.selectedProduct.categoryName || 'Menu',
  //         selectedFreeSides: selectedFreeSidesFullInfo // Store full free sides objects
  //     };

  //     // Check if same product exists with same type AND same extras AND same free sides
  //     const existingItemIndex = cartItems.findIndex(item => {
  //       // First check if it's the same product and type
  //       if (item.id !== newItem.id || item.selectedTypeId !== newItem.selectedTypeId) {
  //           return false;
  //       }
        
  //       // Compare extras using the new format
  //       const areExtrasEqual = this.areExtrasEqualNewFormat(item.selectedExtraId, newItem.selectedExtraId);
        
  //       // Compare free sides using full objects
  //       const areFreeSidesEqual = this.areFreeSidesEqualObjects(item.selectedFreeSides, newItem.selectedFreeSides);
        
  //       return areExtrasEqual && areFreeSidesEqual;
  //   });

  //   if (existingItemIndex > -1) {
  //       // Update quantity if same product, type, extras AND free sides
  //       cartItems[existingItemIndex].quantity += newItem.quantity;
  //       this.alertService.success(`Quantity updated (${cartItems[existingItemIndex].quantity})`);
  //   } else {
  //       // Add as new item if different product, type, extras OR free sides
  //       cartItems.push(newItem);
  //       this.alertService.success('Added to cart'); 
  //   }

  //   // Save updated cart
  //   sessionStorage.setItem('cartItems', JSON.stringify(cartItems));
  //   console.log('Updated cart:', cartItems);
  // }
   private areExtrasEqualNewFormat(extras1: any[], extras2: any[]): boolean {
    if (!extras1 && !extras2) return true;
    if (!extras1 || !extras2) return false;
    if (extras1.length !== extras2.length) return false;
    
    // Sort both arrays by name for consistent comparison
    const sorted1 = [...extras1].sort((a, b) => a.name.localeCompare(b.name));
    const sorted2 = [...extras2].sort((a, b) => a.name.localeCompare(b.name));
    
    // Compare each extra by name, quantity, and price
    return sorted1.every((extra, index) => 
        extra.name === sorted2[index].name &&
        extra.quantity === sorted2[index].quantity &&
        extra.price === sorted2[index].price
    );
  }
  // private areFreeSidesEqualObjects(sides1: any[], sides2: any[]): boolean {
  //     if (!sides1 && !sides2) return true;
  //     if (!sides1 || !sides2) return false;
  //     if (sides1.length !== sides2.length) return false;
      
  //     // Sort both arrays by id for consistent comparison
  //     const sorted1 = [...sides1].sort((a, b) => a.id - b.id);
  //     const sorted2 = [...sides2].sort((a, b) => a.id - b.id);
      
  //     // Compare each side by id, name, and price
  //     return sorted1.every((side, index) => 
  //         side.id === sorted2[index].id &&
  //         side.name === sorted2[index].name &&
  //         side.price === sorted2[index].price
  //     );
  // }

  // new code for free sides
  freeSideQuantities: { [key: number]: number } = {};
  increaseFreeSideQuantity(side: any) {
    if (!this.freeSideQuantities[side.id]) {
      this.freeSideQuantities[side.id] = 0;
    }
    
    // Check if we can add more free sides
    if (this.getTotalFreeSidesQuantity() < this.selectedProduct.free_side) {
      this.freeSideQuantities[side.id]++;
      this.updateSelectedFreeSides();
    } else {
      this.alertService.danger(`You can only select ${this.selectedProduct.free_side} free sides in total`);
    }
  }

  decreaseFreeSideQuantity(side: any) {
    if (this.freeSideQuantities[side.id] > 0) {
      this.freeSideQuantities[side.id]--;
      this.updateSelectedFreeSides();
    }
  }

  getFreeSideQuantity(sideId: number): number {
    return this.freeSideQuantities[sideId] || 0;
  }

  getTotalFreeSidesQuantity(): number {
    return Object.values(this.freeSideQuantities).reduce((sum, quantity) => sum + quantity, 0);
  }

  updateSelectedFreeSides() {
    this.selectedFreeSides = [];
    
    if (this.selectedProduct.sideproducts) {
      this.selectedProduct.sideproducts.forEach(side => {
        const quantity = this.freeSideQuantities[side.id] || 0;
        if (quantity > 0) {
          // Add the side product multiple times based on quantity
          for (let i = 0; i < quantity; i++) {
            this.selectedFreeSides.push(side);
          }
        }
      });
    }
  }
  selectProduct(productId: number) {
    if (productId) {
      this.apiService.getSelectedProduct(productId).subscribe({
        next: response => {
          this.selectedProduct = response.data.selectedProduct;
          console.log(this.selectedProduct);
          
          // Reset selections
          this.selectedExtras = [];
          this.selectedFreeSides = [];
          this.extraQuantities = {};
          this.freeSideQuantities = {}; // NEW: Reset free side quantities
          
          // Initialize extras with quantity 0
          if (this.selectedProduct.extraproducts) {
            this.selectedProduct.extraproducts.forEach(extra => {
              this.extraQuantities[extra.id] = 0;
            });
          }
          
          // NEW: Initialize free sides with quantity 0
          if (this.selectedProduct.sideproducts) {
            this.selectedProduct.sideproducts.forEach(side => {
              this.freeSideQuantities[side.id] = 0;
            });
          }
          
          // Auto-select first size if available
          if (this.selectedProduct.types?.length) {
            this.selectedSize = this.selectedProduct.types[0].id;
          }
        }, 
        error: (error: HttpErrorResponse) => {
          console.log(error);
          this.alertService.danger('Something went wrong!');
        }
      });
    }
  }
  calculateOriginalTotal(): number {
    if (!this.selectedProduct || !this.selectedSize) return 0;
    
    const selectedType = this.selectedProduct.types.find(t => t.id === this.selectedSize);
    if (!selectedType) return 0;
    
    let total = selectedType.price * this.quantity;
    
    // Add extras
    if (this.selectedProduct.extraproducts) {
      this.selectedProduct.extraproducts.forEach(extra => {
        const quantity = this.extraQuantities[extra.id] || 0;
        if (quantity > 0) {
          total += extra.price * quantity * this.quantity;
        }
      });
    }
    
    // Update: Add free sides with price and quantity
    if (this.selectedProduct.sideproducts) {
      this.selectedProduct.sideproducts.forEach(side => {
        const quantity = this.freeSideQuantities[side.id] || 0;
        if (quantity > 0 && side.price && side.price > 0) {
          total += side.price * quantity * this.quantity;
        }
      });
    }
    
    return total;
  }
  calculateTotal(): number {
    if (!this.selectedProduct || !this.selectedSize) return 0;
    
    // Find the selected size
    const selectedType = this.selectedProduct.types.find(t => t.id === this.selectedSize);
    if (!selectedType) return 0;
    
    // Calculate base price (with discount if applicable)
    let basePrice = this.selectedProduct.offer 
      ? this.calculateDiscountedPrice2(this.selectedProduct, selectedType.price)
      : selectedType.price;
    
    let total = basePrice * this.quantity;
    
    // Add extras with quantity
    if (this.selectedProduct.extraproducts) {
      this.selectedProduct.extraproducts.forEach(extra => {
        const quantity = this.extraQuantities[extra.id] || 0;
        if (quantity > 0) {
          total += extra.price * quantity * this.quantity;
        }
      });
    }
    
    // Update: Add free sides with price and quantity
    if (this.selectedProduct.sideproducts) {
      this.selectedProduct.sideproducts.forEach(side => {
        const quantity = this.freeSideQuantities[side.id] || 0;
        if (quantity > 0 && side.price && side.price > 0) {
          total += side.price * quantity * this.quantity;
        }
      });
    }
    
    return total;
  }
  addToCart() {
    if (!this.selectedSize) {
      this.alertService.danger('Please select a size');
      return;
    }

    const selectedType = this.selectedProduct.types.find(
      (t: any) => t.id === this.selectedSize
    );

    // Create extras array with name, quantity, and price
    const extras: any[] = [];
    if (this.selectedProduct.extraproducts) {
      this.selectedProduct.extraproducts.forEach(extra => {
        const quantity = this.extraQuantities[extra.id] || 0;
        if (quantity > 0) {
          extras.push({
            name: extra.name,
            quantity: quantity,
            price: extra.price
          });
        }
      });
    }

    // Update: Get free sides with quantities
    const freeSides: any[] = [];
    if (this.selectedProduct.sideproducts) {
      this.selectedProduct.sideproducts.forEach(side => {
        const quantity = this.freeSideQuantities[side.id] || 0;
        if (quantity > 0) {
          freeSides.push({
            id: side.id,
            name: side.name,
            quantity: quantity,
            price: side.price
          });
        }
      });
    }

    const cartItem = {
      products: [{
        product_id: this.selectedProduct.id,
        type: selectedType.id,
        quantity: this.quantity,
        extra: extras, // Array of objects with name, quantity, price
        side: freeSides // Array of objects with id, name, quantity, price
      }]
    };
    
    console.log('Cart item for API:', cartItem);

    const guestMode = sessionStorage.getItem('guestMode');
    const token = localStorage.getItem('fontana_token')?.toString();
    
    if (cartItem) {
      if (token) {
        if (this.selectedProduct.id) {
          this.apiService.addToCart(cartItem).subscribe({
            next: response => {
              if (response.success == true) {
                this.alertService.success(response.message);
              }
            }, 
            error: (error: HttpErrorResponse) => {
              this.alertService.danger(error.error.message);
            }
          });
        }
      } else if (guestMode) {
        this.handleGuestCart(selectedType, extras, freeSides);
      } else {
        this.alertService.danger('You must be logged in or <a (click)="enableGuestMode()">continue as a guest</a> to add products to your cart');
      }
    }
  }
  private handleGuestCart(selectedType: any, extras: any[], freeSides: any[]) {
    // Get existing cart items or initialize empty array
    let cartItems: any[] = [];
    const storedCart = sessionStorage.getItem('cartItems');
    
    if (storedCart) {
      try {
        cartItems = JSON.parse(storedCart);
        if (!Array.isArray(cartItems)) {
          cartItems = []; // Reset if corrupted data
        }
      } catch (e) {
        console.error('Error parsing cart items', e);
        cartItems = [];
      }
    }

    // Get free sides with full information including quantities
    const selectedFreeSidesFullInfo: any[] = [];
    if (this.selectedProduct.sideproducts) {
      this.selectedProduct.sideproducts.forEach(side => {
        const freeSideItem = freeSides.find(fs => fs.id === side.id);
        if (freeSideItem) {
          selectedFreeSidesFullInfo.push({
            id: side.id,
            name: side.name,
            abbrev: side.abbrev,
            price: side.price,
            quantity: freeSideItem.quantity
          });
        }
      });
    }

    // Prepare the new item in the exact format you want
    const newItem = {
      id: this.selectedProduct.id,
      name: this.selectedProduct.name,
      avatar: this.selectedProduct.avatar,
      offer: this.selectedProduct.offer,
      rate: this.selectedProduct.rate || 0,
      components: this.selectedProduct.components,
      types: this.selectedProduct.types,
      extraproducts: this.selectedProduct.extraproducts,
      selectedTypeId: selectedType.id,
      selectedExtraId: extras, // Store extras directly in selectedExtraId as objects
      quantity: this.quantity,
      category_name: this.selectedProduct.categoryName || 'Menu',
      selectedFreeSides: selectedFreeSidesFullInfo // Store free sides with quantities
    };

    // Check if same product exists with same type AND same extras AND same free sides
    const existingItemIndex = cartItems.findIndex(item => {
      // First check if it's the same product and type
      if (item.id !== newItem.id || item.selectedTypeId !== newItem.selectedTypeId) {
        return false;
      }
      
      // Compare extras using the new format
      const areExtrasEqual = this.areExtrasEqualNewFormat(item.selectedExtraId, newItem.selectedExtraId);
      
      // Compare free sides using full objects with quantities
      const areFreeSidesEqual = this.areFreeSidesEqualObjects(item.selectedFreeSides, newItem.selectedFreeSides);
      
      return areExtrasEqual && areFreeSidesEqual;
    });

    if (existingItemIndex > -1) {
      // Update quantity if same product, type, extras AND free sides
      cartItems[existingItemIndex].quantity += newItem.quantity;
      this.alertService.success(`Quantity updated (${cartItems[existingItemIndex].quantity})`);
    } else {
      // Add as new item if different product, type, extras OR free sides
      cartItems.push(newItem);
      this.alertService.success('Added to cart'); 
    }

    // Save updated cart
    sessionStorage.setItem('cartItems', JSON.stringify(cartItems));
    console.log('Updated cart:', cartItems);
  }
  private areFreeSidesEqualObjects(sides1: any[], sides2: any[]): boolean {
    if (!sides1 && !sides2) return true;
    if (!sides1 || !sides2) return false;
    if (sides1.length !== sides2.length) return false;
    
    // Group by side id and sum quantities for comparison
    const groupSides = (sides: any[]) => {
      const grouped: any = {};
      sides.forEach(side => {
        if (!grouped[side.id]) {
          grouped[side.id] = {
            id: side.id,
            name: side.name,
            price: side.price,
            quantity: side.quantity || 1 // Use quantity property if available
          };
        } else {
          grouped[side.id].quantity += side.quantity || 1;
        }
      });
      return grouped;
    };
    
    const grouped1 = groupSides(sides1);
    const grouped2 = groupSides(sides2);
    
    // Check if all side IDs match
    const sideIds1 = Object.keys(grouped1);
    const sideIds2 = Object.keys(grouped2);
    
    if (sideIds1.length !== sideIds2.length) return false;
    
    // Check each side for equality
    return sideIds1.every(sideId => {
      const side1 = grouped1[sideId];
      const side2 = grouped2[sideId];
      
      return side1 && side2 && 
            side1.id === side2.id &&
            side1.name === side2.name &&
            side1.price === side2.price &&
            side1.quantity === side2.quantity;
    });
  }
}
